import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import SectionPage from "./pages/SectionPage";
import IndustriesPage from "./pages/IndustriesPage";
import IndustryDetailPage from "./pages/IndustryDetailPage";
import FiveMCommercePage from "./pages/FiveMCommercePage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import DemoAccess from "./pages/DemoAccess";
import BookCallPage from "./pages/BookCallPage";
import LegalPage from "./pages/LegalPage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import ResourcesPage from "./pages/ResourcesPage";
import ResourceDetailPage from "./pages/ResourceDetailPage";
import WorkPage from "./pages/WorkPage";
import CaseStudyPage from "./pages/CaseStudyPage";
import AboutPage from "./pages/AboutPage";
import NotFound from "./pages/NotFound";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import SeoManager from "./components/SeoManager";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
        <LanguageProvider>
          <BrowserRouter>
            <SeoManager />
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/demo" element={<DemoAccess />} />
              <Route path="/how-it-works" element={<SectionPage section="how-it-works" />} />
              <Route path="/pricing" element={<SectionPage section="pricing" />} />
              <Route path="/modules" element={<SectionPage section="modules" />} />
                <Route path="/plans" element={<SectionPage section="plans" />} />
                <Route path="/contact" element={<SectionPage section="contact" />} />
                <Route path="/book-call" element={<BookCallPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/services/:slug" element={<ServiceDetailPage />} />
                <Route path="/resources" element={<ResourcesPage />} />
                <Route path="/resources/:slug" element={<ResourceDetailPage />} />
                <Route path="/work" element={<WorkPage />} />
                <Route path="/work/:slug" element={<CaseStudyPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/privacy" element={<LegalPage pageId="privacy" />} />
                <Route path="/terms" element={<LegalPage pageId="terms" />} />
                <Route path="/cookies" element={<LegalPage pageId="cookies" />} />
                <Route path="/industries" element={<IndustriesPage />} />
                <Route path="/industries/clinics-aesthetics" element={<IndustryDetailPage industryId="clinics-aesthetics" />} />
                <Route path="/industries/dental-practices" element={<IndustryDetailPage industryId="dental-practices" />} />
                <Route path="/industries/real-estate" element={<IndustryDetailPage industryId="real-estate" />} />
                <Route path="/industries/restaurants-hospitality" element={<IndustryDetailPage industryId="restaurants-hospitality" />} />
                <Route path="/industries/furniture-interiors" element={<IndustryDetailPage industryId="furniture-interiors" />} />
                <Route path="/industries/professional-services" element={<IndustryDetailPage industryId="professional-services" />} />
                <Route path="/industries/ecommerce-dropshipping" element={<IndustryDetailPage industryId="ecommerce-dropshipping" />} />
                <Route path="/industries/gaming-communities" element={<IndustryDetailPage industryId="gaming-communities" />} />
                <Route path="/solutions/fivem-commerce-platform" element={<FiveMCommercePage />} />
                <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </LanguageProvider>
      </AdminAuthProvider>
    </div>
  );
}

export default App;
